import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { CreatingOpportSearchResult, SearchAdvanced } from '@interfaces'
import { Observable, map } from 'rxjs'

@Injectable({
	providedIn: 'root'
})
export class SearchService {
	private http = inject(HttpClient)
	url = '/search-engine/search'

	// Recoge los contactos y las empresas que coincidan con la búsqueda
	getContactAndEnterprise(data: SearchAdvanced): Observable<CreatingOpportSearchResult[]> {
		return this.http
			.post(`${this.url}/advanced`, data, {
				headers: { Accept: 'application/x-ndjson' },
				responseType: 'text'
			})
			.pipe(
				map(data => {
					const splitData = data.split('\n').filter(data => data)
					return splitData.map(d => JSON.parse(d))
				})
			)
	}
}
